<mat-card fxLayout="column" fxFlex>
  <mat-card-header fxLayout="row" fxLayoutAlign="start center">
    <div mat-card-avatar>
      <mat-icon [svgIcon]="iconForCard"></mat-icon>
    </div>
    <mat-card-title class="antialiased">
      <h3 class="font-weight-semibold">{{ titleForCard | bmsTranslate: {count: 1} }}</h3>
    </mat-card-title>
    <div class="actions" fxLayoutAlign="end center" fxFlex>
      <button mat-icon-button class="mat-icon-action-button-lg-with-border" [matTooltip]="'GENERAL.ACTIONS.DOWNLOAD' | bmsTranslate" (click)="downloadExternalApplication()">
        <mat-icon svgIcon="download-24px"></mat-icon>
      </button>
    </div>
  </mat-card-header>
  <mat-card-content fxLayout="row" fxLayoutAlign="center center" fxFlex="124px">
    <vdw-progress-button [inProgress]="isOpeningExternalApplication" label="TEXEDIT_CARDS.EXTERNAL_APPLICATIONS.ACTION" (progressClick)="openExternalApplication()"></vdw-progress-button>
  </mat-card-content>
</mat-card>
